import { z } from "@/zod";

export const VALIDATION_EMPTY = "empty";
export const VALIDATION_EMAIL = "email";
export const VALIDATION_PHONE = "phone";
export const VALIDATION_DATE = "date";
export const VALIDATION_PRICE = "price";
export const VALIDATION_QUANTITY = "quantity";

export const VALIDATION = [
  VALIDATION_EMPTY,
  VALIDATION_EMAIL,
  VALIDATION_PHONE,
  VALIDATION_DATE,
  VALIDATION_PRICE,
  VALIDATION_QUANTITY,
] as const;

export default z.enum(VALIDATION);
